/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Signin
 * @export
 * @interface PostAuthSigninRequest
 */
export interface PostAuthSigninRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAuthSigninRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PostAuthSigninRequest
     */
    password: string;
}

/**
 * Check if a given object implements the PostAuthSigninRequest interface.
 */
export function instanceOfPostAuthSigninRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PostAuthSigninRequestFromJSON(json: any): PostAuthSigninRequest {
    return PostAuthSigninRequestFromJSONTyped(json, false);
}

export function PostAuthSigninRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAuthSigninRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function PostAuthSigninRequestToJSON(value?: PostAuthSigninRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

